import { FC } from 'react'
import { useUA } from 'context'
import Link from 'next/link'
import styled, { css } from 'styled-components'
import ExamButton from '@app.feature/exam/components/Button/ExamButton'
import { SAMSUNG_INTERVIEW_BOARD_SLUG } from '@app.feature/exam/constants/gsatCommunity'
import { XEN_HOSTNAME } from 'utils/config'

const InterviewStudyLink: FC = () => {
  const { isMobile } = useUA()

  return (
    <StyledWrapper isMobile={!!isMobile}>
      <Link href={`https://${XEN_HOSTNAME}/${SAMSUNG_INTERVIEW_BOARD_SLUG}`}>
        <ExamButton className="study-btn" color="gsat">
          삼성 면접 스터디 모집방 바로가기
        </ExamButton>
      </Link>
    </StyledWrapper>
  )
}

export default InterviewStudyLink

type TStyledWrapper = {
  isMobile: boolean
}

const desktopStyles = css`
  .study-btn {
    width: 460px;
    height: 76px;

    > span {
      font-size: 22px;
    }
  }
`

const mobileStyles = css`
  .study-btn {
    width: 100%;
    height: 50px;

    > span {
      font-size: 16px;
    }
  }
`

const StyledWrapper = styled.div<TStyledWrapper>`
  ${({ isMobile }) => (isMobile ? mobileStyles : desktopStyles)}
`
